(function () {
  if (window.__resoCommunity) return;
  window.__resoCommunity = true;

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-community-open]');
    if (opener) {
      event.preventDefault();
      var dialog = document.getElementById(opener.getAttribute('data-community-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        var scrollY = window.scrollY;
        dialog.showModal();
        window.scrollTo(0, scrollY);
      }
    }

    var closer = event.target.closest('[data-community-close]');
    if (closer) {
      var parentDialog = closer.closest('dialog');
      if (parentDialog) parentDialog.close();
    }
  });

  document.querySelectorAll('dialog.community-dialog, dialog.story-modal').forEach(function (dialog) {
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  });

  document.querySelectorAll('[data-community-stories]').forEach(function (root) {
    var modal = root.querySelector('.story-modal');
    if (!modal) return;

    root.querySelectorAll('[data-story]').forEach(function (tile) {
      var openStory = function () {
        var img = tile.querySelector('img');
        var modalImg = modal.querySelector('img');
        modalImg.src = img.currentSrc || img.src;
        modalImg.alt = img.alt || '';
        modalImg.style.objectPosition = img.style.objectPosition || '';
        modal.querySelector('[data-modal-quote]').textContent = tile.querySelector('[data-quote]').textContent;
        modal.querySelector('[data-modal-who]').innerHTML = tile.querySelector('[data-who]').innerHTML;
        modal.showModal();
      };

      tile.addEventListener('click', openStory);
      tile.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openStory();
        }
      });
    });
  });
})();
